exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs .nav-item.show .nav-link[data-v-2e141dbc],.nav-tabs .nav-link.active[data-v-2e141dbc]{color:#00937f}a[data-v-2e141dbc]{color:#000;background-color:transparent;text-decoration:none}", ""]);

// exports
